var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-group',{attrs:{"label":_vm.label}},[_c('b-form-textarea',{attrs:{"value":_vm.value},on:{"change":function($event){return _vm.$emit('input', $event)}}}),(_vm.desc)?_c('small',[_vm._v(_vm._s(_vm.desc))]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }